module.exports = __webpack_public_path__ + "media/images/lb/076-c4b20f78989e59be4c93b1ab7d305f81.svg";